module.exports = __webpack_public_path__ + "static/media/rightImg3.9236d1c2.png";